import { Box, FormControlLabel, TextField, TextFieldProps } from '@mui/material';
import { WO2Checkbox } from 'src/common';
import { BaseReportComponentProps, MdaReportType, MdaReportTypes } from '../../store/types';
import React from 'react';
import { DateRange } from 'src/store';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterLuxon from '@mui/lab/AdapterLuxon';
import { DateTime } from 'luxon';

export interface UXChangeTaxStatementReportProps extends BaseReportComponentProps {
  setUXChangeTaxStatementSelectedParameter: ActionCreatorWithPayload<boolean, string>;
  setDateRangeUXChangeTaxStatementParameter: ActionCreatorWithPayload<DateRange, string>;
}

export const UXChangeTaxStatementReport = ({
  parameters,
  setUXChangeTaxStatementSelectedParameter,
  setDateRangeUXChangeTaxStatementParameter,
  createReportSortRequest,
}: UXChangeTaxStatementReportProps) => {
  const handleClickSelect = () => {
    setUXChangeTaxStatementSelectedParameter(!parameters.selectedReports.uXchangeTaxStatement.selected);
    createReportSortRequest(
      !parameters.selectedReports.uXchangeTaxStatement.selected,
      MdaReportTypes.UXChangeTaxStatement.id,
      MdaReportTypes.UXChangeTaxStatement.displayName
    );
  };

  const handleClickDate = (date: DateTime | null) => {
    if (!date || !date.isValid) return;

    const year = date.year;
    const dateRange: DateRange = {
      dateFrom: DateTime.fromObject({ year: year - 1, month: 7, day: 1 }).toISODate(),
      dateTo: DateTime.fromObject({ year, month: 6, day: 30 }).toISODate(),
    };
    setDateRangeUXChangeTaxStatementParameter(dateRange);
  };

  return (
    <Box ml={6} display="flex" alignItems="center" mt={1} mb={1}>
      <FormControlLabel
        aria-label="Acknowledge"
        onClick={(event) => event.stopPropagation()}
        onFocus={(event) => event.stopPropagation()}
        control={
          <WO2Checkbox color="primary" checked={parameters.selectedReports.uXchangeTaxStatement.selected} onChangeHandler={handleClickSelect} />
        }
        sx={{ flex: 1 }}
        label={MdaReportType.UXChangeTaxStatement}
      />
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <DatePicker
          label="Financial Year"
          views={['year']}
          value={
            parameters.selectedReports.uXchangeTaxStatement.toDate ? DateTime.fromISO(parameters.selectedReports.uXchangeTaxStatement.toDate) : null
          }
          onChange={handleClickDate}
          minDate={DateTime.fromObject({ year: 2000 })}
          maxDate={DateTime.fromObject({ year: DateTime.now().year, month: 6, day: 30 })}
          renderInput={(props: TextFieldProps) => <TextField sx={{ minWidth: 194, maxWidth: 194, mr: 1 }} {...props} />}
        />
      </LocalizationProvider>
    </Box>
  );
};
